import gql from 'graphql-tag';

export const GET_REGIONS = gql`
  query {
    regions {
      id
      name
    }
  }
`;

export const GET_ORDERS = gql`
  query Errors($regionId: ID!, $first: Int, $after: Int, $filter: String) {
    order(regionId: $regionId, first: $first, after: $after, filter: $filter) {
      totalCount
      order{
        createdAt
        id
        errors
        order
        regionId
        updatedAt
        websiteId
      }

      }
    clubs(regionId: $regionId) {
      id
      name
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/graphql/index.ts